import React from 'react';

import {SpinningLoader} from '@/components';

import {TransactionLimitDisplay} from './TransactionLimitDisplay';
import {TransactionTypeProcessors} from './TransactionTypeProcessors';
import type {TransactionTypeTabProps} from './types';

const initialBusinessLimits = {
  minTransactionLimit: 0,
  maxDailyLimit: 0,
  maxTransactionLimit: 0,
  transactionFrequencyThreshold: 0,
};

const TransactionTypeTab: React.FC<TransactionTypeTabProps> = ({
  transactionType,
  business,
  onRemoveProcessor,
  isLoading,
}) => {
  const limits = {
    ...initialBusinessLimits,
    ...business?.[transactionType]?.limits,
  };

  if (isLoading) {
    return (
      <div className="flex w-full h-full justify-center items-center my-5">
        <SpinningLoader size={6} />
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {Object.entries(limits || {}).map(([key, value]) => {
        return (
          <TransactionLimitDisplay
            key={`${transactionType}_${key}`}
            label={key}
            limit={value}
          />
        );
      })}
      <TransactionTypeProcessors
        transactionType={transactionType}
        business={business}
        onRemove={onRemoveProcessor}
      />
    </div>
  );
};

export default TransactionTypeTab;
